module.exports = __webpack_public_path__ + "img/zxpx.c2ac3879.jpg";